/**
 * @generated SignedSource<<c0f073982183b568fa46c1fff6ccfebe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SingleSelectFieldFragment$data = {
  readonly color: ProjectV2SingleSelectFieldOptionColor;
  readonly field: {
    readonly " $fragmentSpreads": FragmentRefs<"SingleSelectFieldConfigFragment">;
  };
  readonly id: string;
  readonly name: string | null;
  readonly nameHTML: string | null;
  readonly optionId: string | null;
  readonly " $fragmentType": "SingleSelectFieldFragment";
};
export type SingleSelectFieldFragment$key = {
  readonly " $data"?: SingleSelectFieldFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SingleSelectFieldFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SingleSelectFieldFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SingleSelectFieldConfigFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "ProjectV2ItemFieldSingleSelectValue",
  "abstractKey": null
};

(node as any).hash = "7fb9da2903b306061d4defa8cf557540";

export default node;
